import {
  CollapseButton,
  LabeledText,
} from '../../../../common/components/defaultUIComponents';
import { ChangeRequest } from '~/common/entities/ChangeRequest/ChangeRequestType';
import { Collapse, Flex, IconButton, Text } from '@chakra-ui/react';
import { Project } from '~/common/entities/Project/ProjectTypes';
import useTranslate from '../../../../common/utils/translate';
import JobTile from '../../../../common/components/JobTile';
import { DeleteIcon } from '@chakra-ui/icons';
import React from 'react';

type CopyToProjectDetailsProps = {
  changeRequest: ChangeRequest;
  openCollapse: boolean;
  setOpenCollapse: (value: boolean) => void;
  toggleOpenDeleteDialog: () => void;
  projectOfJob: Project;
};

export const CopyToProjectDetails: React.FC<CopyToProjectDetailsProps> = ({
  changeRequest,
  openCollapse,
  setOpenCollapse,
  toggleOpenDeleteDialog,
  projectOfJob,
}) => {
  const translate = useTranslate();
  const toggleOpenCollapse = () => {
    setOpenCollapse(!openCollapse);
  };

  return (
    <>
      <Flex>
        <CollapseButton
          isOpen={openCollapse}
          toggleIsOpen={toggleOpenCollapse}
          mr={1}
        />
        <IconButton
          icon={<DeleteIcon />}
          onClick={toggleOpenDeleteDialog}
          aria-label={translate('changeRequest.delete')!}
          isRound
        />
      </Flex>
      <Collapse in={openCollapse}>
        <>
          {projectOfJob?.jobs &&
            [
              projectOfJob.jobs.find((job) => job.id === changeRequest.job.id),
              ...projectOfJob.jobs,
            ].map(
              (job, index) =>
                job && (
                  <>
                    {index === 0 && (
                      <Text fontWeight="semibold">
                        {translate('changeRequest.jobname')}
                      </Text>
                    )}
                    <JobTile
                      key={index == 0 ? -1 : job.id}
                      job={job}
                      noIcons={true}
                      project={projectOfJob}
                      markThisJob={index == 0}
                      copyStep={index == 0}
                      changeRequest={index == 0 ? changeRequest : null}
                      projectId={
                        index == 0
                          ? (changeRequest.copy_to_project?.id ?? -1)
                          : -1
                      }
                    />
                    {index === 0 && (
                      <LabeledText
                        fontWeight="semibold"
                        label={'changeRequest.containingProjectname'}
                      >
                        {projectOfJob.name + ':'}
                      </LabeledText>
                    )}
                  </>
                ),
            )}
          {changeRequest.copy_to_project?.jobs?.map((job, index) => (
            <>
              {index === 0 && (
                <LabeledText
                  fontWeight="semibold"
                  label={'changeRequest.copytoProjectname'}
                >
                  {changeRequest.copy_to_project?.name}
                </LabeledText>
              )}
              <JobTile
                key={job.id}
                job={job}
                project={changeRequest.copy_to_project}
                markThisJob={job.id == changeRequest.job.id}
              />
            </>
          ))}
        </>
      </Collapse>
    </>
  );
};
